import React, { FunctionComponent, SVGProps } from 'react'

export const IconWhatsapp: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6 2.30098C12.1 0.800977 10.1 0.000976562 8 0.000976562C3.6 0.000976562 0 3.60098 0 8.00098C0 9.40098 0.400006 10.801 1.10001 12.001L0 16.001L4.20001 14.901C5.40001 15.501 6.7 15.901 8 15.901C12.4 15.901 16 12.301 16 7.90098C16 5.80098 15.1 3.80098 13.6 2.30098ZM8 14.601C6.8 14.601 5.60001 14.301 4.60001 13.701L4.39999 13.601L1.89999 14.301L2.60001 11.901L2.39999 11.601C1.69999 10.501 1.39999 9.30098 1.39999 8.10098C1.39999 4.50098 4.4 1.50098 8 1.50098C9.8 1.50098 11.4 2.20098 12.7 3.40098C14 4.70098 14.6 6.30098 14.6 8.10098C14.6 11.601 11.7 14.601 8 14.601ZM11.6 9.60098C11.4 9.50098 10.4 9.00098 10.2 9.00098C10 8.90098 9.89999 8.90098 9.79999 9.10098C9.69999 9.30098 9.30001 9.70098 9.20001 9.90098C9.10001 10.001 8.99999 10.001 8.79999 10.001C8.59999 9.90098 8.00001 9.70098 7.20001 9.00098C6.60001 8.50098 6.20001 7.80098 6.10001 7.60098C6.00001 7.40098 6.10001 7.30098 6.20001 7.20098C6.30001 7.10098 6.4 7.00098 6.5 6.90098C6.6 6.80098 6.60001 6.70098 6.70001 6.60098C6.80001 6.50098 6.70001 6.40098 6.70001 6.30098C6.70001 6.20098 6.30001 5.20098 6.10001 4.80098C6.00001 4.50098 5.80001 4.50098 5.70001 4.50098C5.60001 4.50098 5.49999 4.50098 5.29999 4.50098C5.19999 4.50098 4.99999 4.50098 4.79999 4.70098C4.59999 4.90098 4.10001 5.40098 4.10001 6.40098C4.10001 7.40098 4.79999 8.30098 4.89999 8.50098C4.99999 8.60098 6.29999 10.701 8.29999 11.501C9.99999 12.201 10.3 12.001 10.7 12.001C11.1 12.001 11.9 11.501 12 11.101C12.2 10.601 12.2 10.201 12.1 10.201C12 9.70098 11.8 9.70098 11.6 9.60098Z"
        stroke="none"
      />
    </svg>
  )
}
